import "./featured-offers-slider.scss";

import React, { useEffect } from "react";
import { Link } from "gatsby";
import { addSpaceInNumbers } from "../../utils";

const FeaturedOffersSlider = ({ trailers, vehicles }) => {
  const availableVehicles = [...trailers, ...vehicles];
  useEffect(() => {
    availableVehicles.sort(() => Math.random() - 0.5);
  });

  const TrailerTile = ({ node }) => {
    return (
      <div className="col-md-4">
        <div className="featured-offers-slider__single-offer">
          <div className="featured-offers-slider__images-holder">
            <div className="row g-0">
              <div className="col-8">
                <div
                  className="featured-offers-slider__main-image"
                  style={{
                    backgroundImage: `url(${node.vehicles.gallery[0]?.sourceUrl})`,
                  }}
                />
              </div>
              <div className="col-4">
                <div
                  className="featured-offers-slider__small-image"
                  style={{
                    backgroundImage: `url(${node.vehicles.gallery[1]?.sourceUrl})`,
                  }}
                />
                <div
                  className="featured-offers-slider__small-image"
                  style={{
                    backgroundImage: `url(${node.vehicles.gallery[2]?.sourceUrl})`,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="featured-offers-slider__offer-title">
            {node.vehicles.name}
          </div>
          <div className="featured-offers-slider__price">
            {node.vehicles.priceDiscount
              ? addSpaceInNumbers(node.vehicles.priceDiscount)
              : addSpaceInNumbers(node.vehicles.price)}{" "}
            zł (brutto)
          </div>
          <div className="center-element">
            <Link to={node.uri} className="btn btn--rounded">
              Sprawdź!
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="featured-offers-slider">
      <h2 className="featured-offers-slider__title">
        Oferty, które mogą Cię zainteresować
      </h2>
      <div className="row justify-content-center">
        {availableVehicles[0] && <TrailerTile {...availableVehicles[0]} />}
        {availableVehicles[1] && <TrailerTile {...availableVehicles[1]} />}
        {availableVehicles[2] && <TrailerTile {...availableVehicles[2]} />}
      </div>
    </div>
  );
};

export default FeaturedOffersSlider;
